module.exports = __webpack_public_path__ + "img/13.ffa8bc2e.jpg";